<div class="context-menu p-2" [style.left.px]="position.x" [style.top.px]="position.y">
  <p class="lead p-2 ps-3 m-0 text-center border-bottom">Drop Options</p>

  <!-- Remove/Clear -->
  <div class="submenu-container">
    <button class="submenu-trigger" (click)="toggleSubmenu('remove', $event)">
      Remove / Clear <i class="bi bi-chevron-right chevron"></i>
    </button>
    <div class="submenu" [class.show]="expandedMenu === 'remove'">
      <button (click)="removeDrop.emit('remove')" [disabled]="!canEdit">Remove Drop</button>
      <button (click)="clearDrop.emit('clear')" [disabled]="!canEdit">Clear Drop</button>
    </div>
  </div>

  <!-- Copy / Paste -->
  <div class="submenu-container">
    <button class="submenu-trigger" (click)="toggleSubmenu('copy', $event)">
      Copy / Paste <i class="bi bi-chevron-right chevron"></i>
    </button>
    <div class="submenu" [class.show]="expandedMenu === 'copy'">
      <button (click)="copyDrop.emit('copy')">Copy Drop</button>
      <button (click)="pasteDropBefore.emit('pasteBefore')" [disabled]="!canEdit">Paste Drop Before</button>
      <button (click)="pasteDropAfter.emit('pasteAfter')" [disabled]="!canEdit">Paste Drop After</button>
      <button (click)="pasteShelf.emit('pasteShelf')" [disabled]="!canEdit">Paste Shelf</button>
    </div>
  </div>

  <!-- Create -->
  <div class="submenu-container">
    <button class="submenu-trigger" (click)="toggleSubmenu('create', $event)">
      Create <i class="bi bi-chevron-right chevron"></i>
    </button>
    <div class="submenu" [class.show]="expandedMenu === 'create'">
      <button (click)="createDropBefore.emit('createBefore')" [disabled]="!canEdit">Create Drop Before</button>
      <button (click)="createDropAfter.emit('createAfter')" [disabled]="!canEdit">Create Drop After</button>
      <button (click)="createShelf.emit('createShelf')" [disabled]="!canEdit">Create Shelf</button>
    </div>
  </div>

  <!-- Settings -->
  <div class="submenu-container">
    <button class="submenu-trigger" (click)="toggleSubmenu('settings', $event)">
      Settings <i class="bi bi-chevron-right chevron"></i>
    </button>
    <div class="submenu" [class.show]="expandedMenu === 'settings'">
      <button (click)="dropSettings.emit('settings')">Drop Settings</button>
    </div>
  </div>
</div>